import type { BaseModelAttributes } from './base';
import { TaskStatus, TaskStatusLabels } from './taskStatus';
import { I18nLabels } from './common';

// ⭐ 统一使用 TaskStatus，保留类型别名以向后兼容
export type AudioGenerationStatus = TaskStatus;
export const AudioGenerationStatus = TaskStatus;

// ⭐ 使用统一的状态标签
export const AudioGenerationStatusLabels: I18nLabels<AudioGenerationStatus> = TaskStatusLabels;

/** 音频记录类型：generation=台词配音，editing=音频编辑 */
export type AudioType = 'generation' | 'editing';

/** 音频编辑子类型 */
export type AudioEditingType = 'voice_change';

export interface IAudioGeneration extends BaseModelAttributes {
  prompt: string;
  spkAudioUrl: string;
  emoAudioUrl?: string;
  emoAlpha?: number;
  emoText?: string;
  useRandom?: boolean;
  speedFactor?: number;
  maxTextTokensPerSegment?: number;
  matchReferenceDuration?: boolean;
  modelId: string;
  status: AudioGenerationStatus;
  taskId?: string;
  resultAudioUrl?: string;
  resultMessage?: string;
  submittedAt?: Date;
  completedAt?: Date;
  userId: string;
  // 音频编辑扩展字段
  audioType?: AudioType;
  editingType?: AudioEditingType;
  rvcModelId?: string;
  pitch?: number;
  indexRate?: number;
  user?: {
    id: string;
    name: string;
    email: string;
  };
}

export interface CreateAudioGenerationRequest {
  prompt: string;
  spkAudioUrl: string;
  emoAudioUrl?: string;
  emoAlpha?: number;
  emoText?: string;
  useRandom?: boolean;
  speedFactor?: number;
  maxTextTokensPerSegment?: number;
  matchReferenceDuration?: boolean;
  modelId: string;
}

export interface UpdateAudioGenerationRequest {
  prompt?: string;
  spkAudioUrl?: string;
  emoAudioUrl?: string;
  emoAlpha?: number;
  emoText?: string;
  useRandom?: boolean;
  speedFactor?: number;
  matchReferenceDuration?: boolean;
  modelId?: string;
  status?: AudioGenerationStatus;
  taskId?: string;
  resultAudioUrl?: string;
  resultMessage?: string;
}

export interface CreateAudioEditingRequest {
  srcAudioUrl: string;
  editingType: AudioEditingType;
  modelId: string;
  rvcModelId: string;
  pitch?: number;
  indexRate?: number;
  f0Method?: string;
}

export interface AudioGenerationQuery {
  search?: string;
  userId?: string;
  status?: AudioGenerationStatus;
  modelId?: string;
  audioType?: AudioType;
}